<template>
  <div>


    <b-card no-body >
      <b-card-body class="px-1 pt-1 pb-0" >

        <div>
          <b-row>
            <!-- Per Page -->
            <b-col
                xl="1"
                md="3"
                sm="6"
                class="mb-sm-1"
            >
              <b-button
                  variant="gradient-primary"
                  @click="leerListaNegra('2')"
                  :disabled="loading"
                  block
                  size="sm"
              >
                <span></span>
                <span v-if="loading"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="RefreshCwIcon" />
              </b-button>

            </b-col>
            <b-col
                xl="3"
                md="3"
                sm="6"
                class="mb-sm-1"
            >

              <v-select
                  id="grupounidad"
                  v-model="area_gestionSelected"
                  :options="area_gestionFiltOpciones"
                  :reduce="area_gestionFiltOpciones => area_gestionFiltOpciones.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar área gestión..."
                  @input="leerListaNegra('3')"
                  class="select-size-sm"

              >
                <span slot="no-options"> Sin datos</span>

              </v-select>

            </b-col>

            <b-col
                xl="3"
                md="3"
                sm="6"
                class="mb-sm-1"
            >
              <v-select
                  id="grupowww"
                  v-model="fechaObservadoSelected"
                  :options="fechaObservadoFiltOpciones"
                  :reduce="fechaObservadoFiltOpciones => fechaObservadoFiltOpciones.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar fecha observación..."
                  @input="leerListaNegra('0')"
                  class="select-size-sm"

              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-col>



            <!-- Search -->
            <b-col
                xl="5"
                md="3"
                sm="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <!-- filter -->
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                        id="filterInput"
                        v-model="filterTable"
                        type="search"
                        placeholder="Buscar"
                        :disabled="loading"
                        @input="filtros2"
                    />
                    <b-input-group-append>
                      <b-button
                          :disabled="!filterTable"
                          @click="filterTable = ''"
                      >
                        Borrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </b-col>

          </b-row>

        </div>



      </b-card-body>

      <b-table
          v-if="$can('read', 'Cosecha Observado Re')"
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tablas."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >

        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>


        <template #cell(codigo_empresa)="data">
          <span style="white-space: nowrap"  v-if="data.value=='001'">AGROVISIÓN</span>
          <span style="white-space: nowrap"  v-else-if="data.value=='002'">ARENA VERDE</span>
          <span style="white-space: nowrap"  v-else>OTROS</span>
        </template>

        <template #cell(dni_trabajador)="data">
          <span style="white-space: nowrap" >{{ data.value }}</span>
        </template>
        <template #cell(nombres_trabajador)="data">
          <span style="white-space: nowrap" >{{ data.value }}</span>
        </template>
        <template #cell(fecha_ultimo_tareo)="data">
          <span style="white-space: nowrap">{{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}</span>
        </template>
        <template #cell(fecha_hora_baja)="data">
          <span style="white-space: nowrap">{{ data.value }}</span>
        </template>

        <template #cell(dias_cosecha_superior_fecha_baja)="data" >
          <span style="white-space: nowrap" class="text-center">{{ data.value }}</span>
        </template>




      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

    </b-card>
  </div>

</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { BFormCheckbox, BCardText } from 'bootstrap-vue'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner
} from 'bootstrap-vue'
import axios from "axios";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr,
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    BCardText,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {

      perPage: 15,
      pageOptions: [2,5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      showRangeFecha:true,
      showFecha:true,
      src: '',
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'codigo_empresa',
          label: 'Empresa',
          sortable: true
        },
        {
          key: 'dni_trabajador',
          label: 'dni trabajador',
          sortable: true
        },
        {
          key: 'nombres_trabajador',
          label: 'nombres trabajador',
          sortable: true
        },
        {
          key: 'fecha_ultimo_tareo',
          label: 'fecha último tareo',
          sortable: true
        },
        {
          key: 'fecha_hora_baja',
          label: 'fecha Observación',
          sortable: true,
        },
        {
          key: 'dias_cosecha_superior_fecha_baja',
          label: 'días cosecha superior fecha baja',
          sortable: true
        },
      ],
      items: [],
      items2:[],
      loading: false,
      show: false,
      selected: [],
      fechaObservadoOpciones:[],
      fechaObservadoFiltOpciones:[],
      fechaObservadoSelected : null,
      filterTable:null,
      area_gestionFiltOpciones:[
        { text: 'OBSERVADOS ÁREA COSECHA', value: 'COSECHA' },
        { text: 'OBSERVADOS ÁREA RR.HH', value: 'RRHH' }
      ],
      area_gestionSelected :'COSECHA',


    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },


  },
  mounted() {
    this.leerListaNegra('2');
  },
  methods: {
    leerListaNegra(tipo){
      var yo = this

      yo.loading = true


      var fecha_observacion = yo.fechaObservadoSelected;

      if(tipo == '2' && fecha_observacion != null && fecha_observacion !='T' ){
        tipo = '0';
      }
      //
      if(fecha_observacion == null){
        fecha_observacion = 'T';
      }else if (fecha_observacion !='T') {
        var arrayDeCadenas = fecha_observacion.split('T');
        var arrfecha = arrayDeCadenas[0].split('-');
        var arrHora = arrayDeCadenas[1].split('Z');
        var arrHora_sep = arrHora[0].split('.');
        var hora_selected = arrHora[0];
        if (arrHora_sep.length>1){
          hora_selected = arrHora_sep[0];
        }
        fecha_observacion = arrfecha[2]+"/"+arrfecha[1]+"/"+arrfecha[0] +" "+hora_selected;
      }

      console.log(tipo)

      // yo.fechaObservadoFiltOpciones = [];

      var config = {
        method: 'get',
        url: '/cosecha/cosecha/observado/tareo/superior/fechabaja/?fecha_observacion='+fecha_observacion+"&area_gestion="+yo.area_gestionSelected,
        headers: { }
      };

      console.log(config);

      axiosIns(config)
          .then((response) => {
            yo.items = response.data.response;
            yo.items2 = response.data.response;
            yo.totalRows = yo.items.length
            yo.c_total_d = yo.totalRows - 3;
            console.log( yo.items);

            if(tipo == '2' || tipo == '3'){
              yo.fechaObservadoOpciones = [];
              yo.fechaObservadoFiltOpciones = [];

              for (let value of yo.items){
                if (value.fecha_fil != null && value.fecha_fil !== '' && value.fecha_fil !== ' ' && value.fecha_fil !== '  ')
                {
                  yo.fechaObservadoFiltOpciones.push({value: value.fecha_fil, text:value.fecha_hora_baja});
                }
              }

              let setObs   = new Set( yo.fechaObservadoFiltOpciones.map( JSON.stringify ) );
              yo.fechaObservadoFiltOpciones = Array.from(setObs).map(JSON.parse);
              yo.fechaObservadoFiltOpciones.sort(function(x, y) {
                var firstDate = new Date(x.value),
                    SecondDate = new Date(y.value);

                if (firstDate > SecondDate) return -1;//if (firstDate < SecondDate) return -1;
                if (firstDate < SecondDate) return 1;//if (firstDate > SecondDate) return 1;

                return 0;
              });
              yo.fechaObservadoFiltOpciones.unshift({value: 'T', text:"TODAS LA FECHAS OBS."});
              yo.fechaObservadoSelected = "T";
            }

          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
        yo.loading = false
      });

    },
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    verSeleccionados(){
      var yo = this;

    },
    selectAll() {
      if (this.allSelected) {
        const selected = this.items.map((u) => u.dni_trabajador);
        this.selected = selected;
      } else {
        this.selected = [];
      }
    },
    filtros2(){
      var palabra = this.filterTable !== null ? this.filterTable.toLowerCase() : ''
      this.items = this.items2
      this.items = this.items.filter(
          invoice =>
              (invoice.dni_trabajador.toLowerCase().includes(palabra) || invoice.nombres_trabajador.toLowerCase().includes(palabra)))
      this.totalRows = this.rowsBajaProductividadFiltro.length
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
